import { render, staticRenderFns } from "./BsChart.vue?vue&type=template&id=4cc919eb&scoped=true"
import script from "./BsChart.vue?vue&type=script&lang=js"
export * from "./BsChart.vue?vue&type=script&lang=js"
import style0 from "./BsChart.vue?vue&type=style&index=0&id=4cc919eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc919eb",
  null
  
)

export default component.exports